/* tslint:disable */
/* eslint-disable */
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../../common/runtime';
/**
 *
 * @export
 * @interface EmailDetails
 */
export interface EmailDetails {
  /**
   * Domain of the email address
   * @type {string | null}
   * @memberof EmailDetails
   */
  domain?: string | null;
  /**
   * Valid email address
   * @type {string}
   * @memberof EmailDetails
   */
  email: string;
  /**
   * Label of the email address
   * @type {string | null}
   * @memberof EmailDetails
   */
  label?: string | null;
}

/**
 * Check if a given object implements the EmailDetails interface.
 */
export function instanceOfEmailDetails(value: object): value is EmailDetails {
  if (!('email' in value) || value['email'] === undefined) return false;
  return true;
}

export function EmailDetailsFromJSON(json: any): EmailDetails {
  return EmailDetailsFromJSONTyped(json, false);
}

export function EmailDetailsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EmailDetails {
  if (json == null) {
    return json;
  }
  return {
    domain: json['domain'] == null ? undefined : json['domain'],
    email: json['email'],
    label: json['label'] == null ? undefined : json['label'],
  };
}

export function EmailDetailsToJSON(value?: EmailDetails | null): any {
  if (value == null) {
    return value;
  }
  return {
    domain: value['domain'],
    email: value['email'],
    label: value['label'],
  };
}
